import type { MapPing } from "~/shared/components/tracking-map/tracking-map.tsx";

/**
 * Ensures consistent pin z-order by placing stop pins on top of tracking pings.
 * This preserves marker visibility hierarchy regardless of which tracking surface uses the map.
 */
export function buildOrderedMapPings(
	trackingPings: readonly MapPing[],
	stopPings: readonly MapPing[],
): MapPing[] {
	// Tracking pins first (rendered first = lower z-order), stop pings last (rendered last = higher z-order)
	return [...trackingPings, ...stopPings];
}
